import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { API } from "../lib/api";

const errText = (err, fallback) => {
  const d = err.response?.data?.detail;
  return typeof d === "string" ? d : Array.isArray(d) ? d.map(e => e.msg).join(" ") : fallback;
};

export const ReportAutomation = () => {
  const [busy, setBusy] = useState(false);
  const sendReminder = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/reminders/run-now`, {});
      window.dispatchEvent(new Event("notifications-updated"));
      if (data.overdue) toast.success(`Pengingat dibuat untuk ${data.overdue} pengajuan dan dikirim ke ${data.supervisors_notified} Supervisor serta ${data.managers_notified} Manager. ${data.email_configured ? `Email terkirim: ${data.email_sent}; gagal/tidak tersedia: ${data.email_not_sent}.` : "Email belum dikonfigurasi."} ${data.whatsapp_configured ? `WhatsApp diterima API: ${data.whatsapp_sent}; gagal: ${data.whatsapp_failed}.` : "WhatsApp belum dikonfigurasi."} Notifikasi dalam aplikasi tetap aktif.`);
      else if (data.pending && data.recently_reminded) toast.info(`${data.pending} pengajuan masih menunggu. ${data.recently_reminded} sudah diingatkan dalam 2 hari terakhir; pengingat berikutnya dikirim setelah jeda 2 hari.`);
      else if (data.pending) toast.info(`${data.pending} pengajuan masih menunggu, tetapi belum berusia lebih dari 48 jam sejak diajukan.`);
      else toast.success("Tidak ada pengajuan yang menunggu persetujuan.");
    } catch (err) {
      toast.error(errText(err, "Gagal mengirim pengingat"));
    } finally {
      setBusy(false);
    }
  };

  return <section className="section-panel automation-panel" data-testid="report-automation">
    <div className="section-head"><div>
      <h2><BellRing size={17} /> Pengingat persetujuan</h2>
      <p className="muted">Notifikasi dalam aplikasi dikirim kepada Supervisor dan Manager jika pengajuan telah menunggu lebih dari 48 jam. Email dikirim jika SMTP sudah dikonfigurasi. Pengingat berikutnya untuk pengajuan yang sama dikirim setelah jeda 2 hari.</p>
    </div></div>
    <div className="automation-actions">
      <button type="button" data-testid="run-reminder-now-button" className="primary-btn" disabled={busy} onClick={sendReminder}>
        <BellRing size={16} /> {busy ? "Mengirim pengingat..." : "Kirim pengingat sekarang"}
      </button>
    </div>
  </section>;
};
